export default __webpack_public_path__ + "static/bg-cs-zappi--mobile-ef68f84ac3d88b2c4d28b79a7308aa23.webp";